module.exports = "<div class=\"add-micro-site-config\">\n  <form name=\"vm.angularForm\" class=\"micro-site-config-edit-form\">\n    <page-loader loading=\"vm.loading\"></page-loader>\n  </form>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/addMicroSiteConfig/template.html
// module id = 1211
// module chunks = 0